/* Self-contained "Learn more" config-modal open/close handler.

   The product page (pdp-config-steps.js) has its own copy, but that script only
   loads on product pages. The quick-add drawer (collection/home/search pages)
   injects the same config markup — including the learn-more button and modal —
   so this small, document-delegated handler is loaded globally (via the
   quick-add-drawer snippet) to make the modal work there too. Operations are
   idempotent, so coexisting with the product page's handler is harmless. */
(function () {
  if (window.__ampdConfigModalBound) return;
  window.__ampdConfigModalBound = true;

  function openConfigModal(m) {
    // The quick-add drawer uses a CSS transform (for its slide animation), which
    // makes position:fixed inside it resolve against the drawer instead of the
    // viewport — trapping the modal inside the drawer. Portal it to <body> so it
    // centres on the whole screen. Remember where it was so we can put it back.
    if (m.parentNode !== document.body) {
      m.__homeParent = m.parentNode;
      m.__homeNext = m.nextSibling;
      document.body.appendChild(m);
    }
    m.hidden = false;
    // next frame so the transition runs from the hidden state
    requestAnimationFrame(function () {
      m.classList.add('is-open');
      document.documentElement.classList.add('config-modal-open');
      var d = m.querySelector('.config-modal__dialog');
      if (d) d.focus();
    });
  }

  function closeConfigModal(m) {
    m.classList.remove('is-open');
    document.documentElement.classList.remove('config-modal-open');
    setTimeout(function () {
      m.hidden = true;
      // Restore to its original location so the drawer can manage/replace it on
      // re-render (avoids an orphaned duplicate with the same id in <body>).
      if (m.__homeParent) {
        if (m.__homeNext && m.__homeNext.parentNode === m.__homeParent) {
          m.__homeParent.insertBefore(m, m.__homeNext);
        } else {
          m.__homeParent.appendChild(m);
        }
        m.__homeParent = null;
        m.__homeNext = null;
      }
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-config-modal-open]') : null;
    if (opener) {
      e.preventDefault();
      var m = document.getElementById(opener.getAttribute('data-config-modal-open'));
      if (m) openConfigModal(m);
      return;
    }
    var closer = e.target.closest ? e.target.closest('[data-config-modal-close]') : null;
    if (closer) {
      var mm = closer.closest('.config-modal');
      if (mm) closeConfigModal(mm);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.config-modal.is-open');
      if (open) closeConfigModal(open);
    }
  });
})();
